import qs from 'qs';
import { apiRequest } from './api';

function toQueryString(params = {}) {
  return qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true });
}

export async function listCourses(params = {}) {
  const query = toQueryString(params);

  return apiRequest(`/courses${query ? `?${query}` : ''}`);
}

export async function listUpcomingCourseSessions(params = {}) {
  const query = toQueryString(params);

  return apiRequest(`/courses/upcoming${query ? `?${query}` : ''}`);
}

export async function listCourseFilters() {
  return apiRequest('/courses/filters');
}

export async function getCourse(courseSlug) {
  return apiRequest(`/courses/${encodeURIComponent(courseSlug)}`);
}
